import type { Situacao } from './api';
import { NOME_DA_SITUACAO, TOM_DA_SITUACAO } from './orcamento';

/**
 * O selo da versão do orçamento (p.24): preenchido, com o ponto na cor 500 e
 * a palavra escrita. É a situação da VERSÃO, e não um dos seis status da
 * máquina: o tom é o de retorno — aprovado verde, rascunho âmbar (falta
 * aprovar), arquivado neutro. O mesmo na mesa e no celular.
 */
const CLASSES = {
  sucesso: { fundo: 'bg-sucesso-fundo text-sucesso-texto', ponto: 'bg-sucesso' },
  atencao: { fundo: 'bg-atencao-fundo text-atencao-texto', ponto: 'bg-atencao' },
  neutro: { fundo: 'bg-nao-alocado-fundo text-nao-alocado-texto', ponto: 'bg-nao-alocado' },
  erro: { fundo: 'bg-erro-fundo text-erro-texto', ponto: 'bg-erro' },
} as const;

export function SeloDaVersao({ situacao }: { readonly situacao: Situacao }) {
  return <SeloDoOrcamento rotulo={NOME_DA_SITUACAO[situacao]} tom={TOM_DA_SITUACAO[situacao]} />;
}

/** O selo do desvio: "Pede explicação" (âmbar) e "Explicado" (verde). */
export function SeloDoOrcamento({ rotulo, tom }: { readonly rotulo: string; readonly tom: keyof typeof CLASSES }) {
  const c = CLASSES[tom];
  return (
    <span className={`inline-flex min-h-[var(--selo-altura)] max-w-full shrink-0 items-center gap-1.5 rounded-pill px-2.5 py-1 ${c.fundo}`}>
      <span aria-hidden="true" className={`size-[var(--selo-ponto)] shrink-0 rounded-pill ${c.ponto}`} />
      <span className="txt-selo leading-tight whitespace-nowrap">{rotulo}</span>
    </span>
  );
}
